import type { NextPage } from 'next';
import React from 'react';
import styles from './index.module.less';
import HomePage from 'components/HomePage';
import CompInfo from 'components/CompInfo';
import Positions from 'components/Positions';
import Product from 'components/Product';
import Environment from 'components/Environment';
import Social from 'components/Social';
import Footer from 'components/Footer';

const Home: NextPage = () => {
  return (
    <div className={styles.mj_container}>
      <HomePage />
      <CompInfo />
      <Positions />
      <Product />
      <Environment />
      <Social />
      <Footer />
    </div>
  );
};

export default Home;
